<template>
  <v-container fluid class="">
    <h3 class='ml-2 mb-3'><v-icon medium class='mr-2' color='black'>far fa-building</v-icon>Organization Management</h3>
    <div>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        @keydown.esc="dialog=false"
        persistent
      >

        <v-card>
          <v-card-title right>
            <h3 class="headline" v-if="this.item.id">Edit Organization</h3>
            <h3 class="headline" v-else>Add Organization</h3>
          </v-card-title>
          <hr class="thick" >

          <v-card-text>
            <v-layout wrap>
              <v-form
                ref="orgForm"
                v-model="form.valid"
                style="width:100%">
                <v-flex xs12>
                  <v-text-field
                    v-model="item.name"
                    :rules="form.required"
                    label="Name*"/>
                </v-flex>
              </v-form>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn
                @click.native="close" flat outline>Cancel</v-btn>
            <v-btn
              color="primary"
              @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <v-btn
        color="primary"
        dark
        class="mb-4 ml-0"
        @click="addItem()"
      >
        <v-icon
          small
          class="mr-1">fa-plus</v-icon>
        Add Organization
      </v-btn>
      <v-data-table
        :headers="headers"
        :items="organizations"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPage"
        class="elevation-1 amaze-data-table"
        sort-icon="arrow_drop_down">
        <template
          slot="items"
          slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-right layout px-0 cardActions">
            <v-menu class='cardMenu hidden-md-and-up' bottom left >
            <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
            <v-list>
              <div>
                <v-list-tile v-on:click="editItem(props.item)">
                  <v-list-tile-title>Edit Organization</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="deleteItem(props.item.id)">
                  <v-list-tile-title>Delete Organization</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn class="hidden-sm-and-down amaze-user-action" slot="activator" @click="editItem(props.item)" icon><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn>
              </div>
            </template>
            <span>Edit organization</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn class="hidden-sm-and-down amaze-user-action" slot="activator" @click="deleteItem(props.item.id)" icon><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn>
              </div>
            </template>
            <span>Delete Organization</span>
          </v-tooltip>
          </td>
        </template>

      </v-data-table>
    </div>
  </v-container>
</template>
<style lang="scss" scoped>
  @import "src/styles/variables.scss";
  button {
    &.amaze-user-action {
      color: rgba(0,0,0,0.87) !important;
      &:hover {
         color: $icon-blue !important;
         svg {
          fill: $icon-blue !important;
          path, text {
            fill: $icon-blue !important;
          }
         }
        * {
          color: $icon-blue;
          fill: $icon-blue;
        }
      }
    }
  }
  .actionsPanel {
    display: flex;
    flex-wrap: wrap;
  }
</style>
<script>
import Sugar from "sugar";
export default {

  data: () => ({
    addMode: false,
    dialog: false,
    headers: [
      { text: 'Name', value: 'name' },
      { text: '', value: null, sortable: false, align: 'right' }
    ],
    organizations: [],
    item: {
      name: null
    },
    form: {
      valid: false,
      required: [v => !!v || 'Please enter a value ']
    },
    pagination: {
      rowsPerPage: 50
    },
    rowsPerPage: [25, 50, 100]
  }),
  computed: { },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  mounted () {
    this.$http.get('organizations').then(
      response => {
        this.organizations = response.body.data
      },
      response => {
        console.log('Error getting organizations.')
      }
    )
  },

  methods: {
    editItem (item) {
      this.item = item
      this.dialog = true
    },
    addItem () {
      this.item = {
        name: null
      }
      this.dialog = true
    },
    deleteItem (orgId) {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$http.delete('organizations/' + orgId).then(
          response => {
            Sugar.Array.remove(this.organizations, function(n) {
              return n.id === orgId
            });
          },
          response => {
            console.log('Error deleting organization.')
          }
        )
      }
    },

    close () {
      this.dialog = false
    },

    save () {
      if (this.$refs.orgForm.validate()) {
        var formData = this.item;

        if (this.item.id) {
          this.$http.put('organizations/' + formData.id, formData).then(
            response => {
              this.$store.commit('updateMessage', {
                message:
                    'Organization updated.',
                snackbar: true
              })
            },
            response => {
              console.log('Error updating organization.')
            }
          )
        } else {
          // create new user
          this.$http.post('organizations/', formData).then(
            response => {
              this.$store.commit('updateMessage', {
                message:
                    'Organization added.',
                snackbar: true
              })
              this.organizations.push(response.body.data)
            },
            response => {
              console.log('Error saving new organization.')
            }
          )
        }
      } else {
        this.$store.commit('updateMessage', {
          message:
              'Nice try, but some required information is missing. Give it another go!',
          snackbar: true
        })
      }
      this.close()
    }
  }
}
</script>
